module.exports = __webpack_public_path__ + "img/2-USB.fe160789.png";